import { OrderTypeEnum } from "@/core/enums";
import { CheckoutOrderValidationError, CheckoutOrderValidationRule } from "../enum/checkout-order-validation.enum";

export const checkoutOrderDeliveryZoneRule: CheckoutOrderValidationRule = ({
	orderTypeName,
	deliveryZoneCount,
	hasUserLocation,
}) => {
	const isDeliveryOrder = orderTypeName === OrderTypeEnum.Delivery;
	const hasDeliveryZone = deliveryZoneCount > 0;

	return isDeliveryOrder && (!hasDeliveryZone || !hasUserLocation)
		? CheckoutOrderValidationError.DeliveryZoneUnavailable
		: null;
};
